import $ from 'jquery';

window.YP.PopOver = function PopOver() {
    const SELECTORS = {
        popOverToggle: '.c-popover__toggle:not(.c-popover__toggle-react)',
        popOverContainer: '.c-popover__container:not(.c-popover__container-react)',
    };

    return {
        init() {
            $(SELECTORS.popOverToggle).removeAttr('disabled');
            $(document).on('click', SELECTORS.popOverToggle, this.togglePopover);
            $(document).on('click', this.hidePopover);
        },
        togglePopover(e) {
            e.stopPropagation();
            const isContainerVisible = $(this).siblings(SELECTORS.popOverContainer).is(':visible');
            // Hide every popup containers and toggle the current one
            $(SELECTORS.popOverContainer).hide();
            if (isContainerVisible) {
                $(this).siblings(SELECTORS.popOverContainer).hide();
            } else {
                $(this).siblings(SELECTORS.popOverContainer).show();
            }
        },
        hidePopover() {
            // Hide every popup containers excepts if the click happened in a container
            if ($(this).hasClass(SELECTORS.popOverContainer)) {
                return;
            }
            $(SELECTORS.popOverContainer).hide();
        },
    };
};

window.addEventListener('load', () => {
    window.YP.PopOver().init();
});
